<template>
  <li>
      <!-- 不通过的可删除 -->
    <i class="el-icon-delete" v-if="item.status==='IdentityCertifieStatusFailed'" @click="delDialog"></i>
    <div class="list_t">
      <div class="list_l">
        <img :src="item.education_certificatePath" />
      </div>
      <div class="list_r">
        <div class="list_r_t">
          <span>{{item.education_name}}</span>
          <span>{{item.education_entrance_date}}-{{item.education_graduate_date}}</span>
        </div>
        <div class="list_r_b">
          <span>{{item.education_speciality}}</span>
          <span>|</span>
          <span>{{item.education_type_name}}</span>
        </div>
      </div>
    </div>
    <!-- 通过不显示 -->
    <div class="list_b" v-if="item.status!=='IdentityCertifieStatussuccess'">
      <span style="color:#3BDD65;" v-if="item.status!=='IdentityCertifieStatusFailed'">审核中</span>
      <span style="color:#F93333;" v-if="item.status==='IdentityCertifieStatusFailed'">审核不通过：{{item.examine_remark}}</span>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    item: {
      type: Object
    }
  },
   methods:{
    delDialog(){
      this.$confirm('是否需要删除该教育经历?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         this.del();
        }).catch();
    },
    del(){
      this.api.deleteFrontExtend({code:this.item.code}).then(res=>{
        if (res.error.err_code !== 0) return;
        this.$message.success('删除成功！');
         this.$parent.getFrontExtends('ExtendTypeEducation');//教育经历
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  padding: 0 28px 10px 30px;
  background: #fff;
  li {
    padding: 20px 0;
    border-bottom: 1px solid #eee;
    position: relative;
    .el-icon-delete{
        position: absolute;
        right: 29px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        display: none;
    }
    &:hover .el-icon-delete{
        display: block;
    }
  }
  li:first-child {
    padding-top: 0;
  }
  li:last-child {
    border-bottom: 0;
  }
  .list_t {
    display: flex;
  }
  .list_b{
      height: 25px;
      display: flex;
      align-items: flex-end;
      font-size: 13px;
  }
  .list_l {
    width: 60px;
    height: 60px;
    overflow: hidden;
    background: #e2e2e2;
    img {
      width: 100%;
    }
  }
  .list_r {
    margin-left: 14px;
    font-size: 14px;
    color: $font-black;
    .list_r_t {
      height: 26px;
      line-height: 26px;
      span {
        margin-right: 33px;
      }
      span:last-child {
        color: $font-gary;
      }
    }
    .list_r_b {
      height: 26px;
      line-height: 26px;
      span:nth-of-type(2) {
        color: #e2e2e2;
        padding: 0 20px;
      }
    }
  }
}
</style>